import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'

export default function contactDataLayerBody(stateId, locations, imovel, path, contactClick, contactOrigin, contactTarget, idLead) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'purchase',
      eventCategory: `${contactOrigin}`,
      eventAction: `${contactTarget}:submit`,
      eventLabel: `${contactClick}:${contactOrigin}:${contactTarget}:${idLead}`,
      ecommerce: {
        purchase: {
          actionField: {
            id: idLead,
          },
          products: {
            id: imovel.imovelId,
            name: TOOLS.slugify(imovel.Nome),
            brand: 'vivaz',
            category: `${TOOLS.slugify(imovel.Localizacao.Estado)}/${TOOLS.slugify(imovel.Localizacao.Cidade)}`,
            variant: `${TOOLS.slugify(imovel.Localizacao.Bairro)}/${TOOLS.slugify(imovel.Quartos)}/${TOOLS.slugify(imovel.AreaPrivativaM2)}`,
            price: imovel.PrecoMinimo ? FILTERS.moneyBi(imovel.PrecoMinimo) : undefined,
          },
        },
      },
      estado: TOOLS.slugify(imovel.Localizacao.Estado),
      cidade: TOOLS.slugify(imovel.Localizacao.Cidade),
      contato: {
        objetivo: contactTarget,
        forma: contactOrigin,
        id: idLead,
      },
      imoveis: !imovel ? undefined : {
        id: imovel.imovelId,
        nome: TOOLS.slugify(imovel.Nome),
        bairro: TOOLS.slugify(imovel.Localizacao.Bairro),
        cidade: TOOLS.slugify(imovel.Localizacao.Cidade),
        estado: TOOLS.slugify(imovel.Localizacao.Estado),
        areaprivativa: imovel.AreaPrivativaM2 ? imovel.AreaPrivativaM2 : undefined,
        dormitorios: TOOLS.slugify(imovel.Quartos),
        vagas: imovel.VagasGaragem,
        valor: imovel.PrecoMinimo ? FILTERS.moneyBi(imovel.PrecoMinimo) : undefined,
        status: imovel.Status ? TOOLS.slugify(imovel.Status) : undefined,
        position: undefined,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/contactDataLayer.js